import React from "react";

const ChecklistItem = ({ text }) => {
  return (
    <li className="flex items-start gap-2">
      <svg
        className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <span className="text-sm text-gray-700">{text}</span>
    </li>
  );
};

export default ChecklistItem;
